// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Sdlh","productName":"Table_productName__37nl2"};